import versionRoute from "../api/version.route";
import { post } from "./lib";

export const getVersion = () => post<typeof versionRoute>("/api/version");
